<template>
  <div>
    <iModal
      title="编辑人员"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="500px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="100"
            @submit.native.prevent
          >
            <FormItem label="人员类型：" prop="groupName">
              <Select
                v-model="formInline.groupName"
                placeholder="请选择人员类型"
              >
                <Option
                  v-for="(item, index) in groupList"
                  :value="item.description"
                  :key="index"
                  >{{ item.description }}</Option
                >
              </Select>
            </FormItem>
            <FormItem label="负责项目：">
              <Input v-model="formInline.worker" placeholder="请输入负责项目" />
            </FormItem>
            <FormItem label="姓名：">
              <Input v-model="formInline.name" placeholder="请输入姓名" />
            </FormItem>
            <FormItem label="Tel：">
              <Input v-model="formInline.tel" placeholder="请输入联系方式" />
            </FormItem>
            <FormItem label="Email：">
              <Input
                type="textarea"
                :rows="5"
                v-model="formInline.email"
                placeholder="请输入邮箱"
              />
            </FormItem>
            <FormItem label="显示顺序：">
              <InputNumber
                :max="9999"
                :min="0"
                v-model="formInline.showIndex"
              ></InputNumber>
            </FormItem>
            <FormItem label="二维码：">
              <div class="my-upload">
                <div
                  class="my-upload-list"
                  v-for="(item, index) in uploadList"
                  :key="'upload' + index"
                >
                  <template v-if="item.status === 'finished'">
                    <img :src="item.url" style="width: 100px; height: 100px" />
                    <div class="my-upload-list-cover">
                      <!-- <Icon
                        type="ios-eye-outline"
                        @click.native="handleView(item.url)"
                      ></Icon> -->
                      <Icon
                        type="ios-trash-outline"
                        @click.native.stop.prevent="handleRemove(item)"
                      ></Icon>
                    </div>
                  </template>
                  <template v-else>
                    <Spin
                      v-if="item.showProgress"
                      style="width: 100px; height: 100px"
                    >
                      <Icon
                        type="ios-loading"
                        size="20"
                        class="demo-spin-icon-load"
                      ></Icon>
                    </Spin>
                  </template>
                </div>
                <Upload
                  ref="upload"
                  :show-upload-list="false"
                  :default-file-list="defaultList"
                  :on-success="handleSuccess"
                  :format="['jpg', 'jpeg', 'png']"
                  :max-size="2048"
                  :headers="formHeaders"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  multiple
                  type="drag"
                  :action="uploadUrl"
                  style="display: inline-block"
                  v-show="uploadList && uploadList.length < limitNum"
                >
                  <div
                    style="
                      width: 100px;
                      height: 100px;
                      padding-top: 18px;
                      color: rgb(133, 133, 133);
                    "
                  >
                    <div style="font-size: 25px">
                      +
                      <p style="font-size: 14px">上传</p>
                    </div>
                  </div>
                  <!-- <img
                  :src="qRcode"
                  
                  style="width: 100px; height: 100px"
                  v-if="qRcode"
                  @click="getRow()"
                /> -->
                </Upload>
              </div>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button
          type="primary"
          :loading="loading"
          @click="handleSubmit('formInline')"
          >确定</Button
        >
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "label-add",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    groupList: {
      type: Array,
      default: [],
    },
    data: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      loading: false,
      showModal: true,
      qRcode:[],
      defaultList: [],
      uploadList: [],
      limitNum: 2,
      formInline: {
        // form双向绑定
        groupName: "",
        worker: "",
        name: "",
        tel: "",
        email: "",
        showIndex: 0,
      },
      ruleInline: {
        groupName: [
          { required: true, message: "人员类型不能为空", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
    }),
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    },
  },
  created() {
    if (this.data) {
      this.formInline.groupName = this.data.groupName;
      this.formInline.worker = this.data.worker;
      this.formInline.name = this.data.name;
      this.formInline.tel = this.data.tel;
      this.formInline.email = this.data.email;
      this.formInline.showIndex = this.data.showIndex;
      if(this.data.qRcode){
      let imgList=this.data.qRcode.split(',')
      console.log(imgList,'343werwer')
      for(let i=0;i<imgList.length;i++){
        let arr={}
        arr.url=imgList[i]
        arr.status='finished'
        this.uploadList.push(arr)
      }
      console.log(this.uploadList,'343werwer')
      }

    }
  },
  methods: {
    ...mapActions({
      editContactUs: "hostCommonModule/editContactUs",
    }),
    async handleSubmit(name) {
      console.log(this.uploadList, "upload");
      if (this.uploadList) {
        this.uploadList.forEach((c) => {
             this.qRcode.push(c.url)
        });
       console.log(this.qRcode.toString)
      }

      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let req = {
        Id: this.data.id,
        SetValues: {
          GroupName: form.groupName,
          Worker: form.worker,
          Name: form.name,
          Tel: form.tel,
          Email: form.email,
          ShowIndex: form.showIndex,
          QRcode: this.qRcode.join(','),
        },
      };
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let bool = await this.editContactUs(req).catch((err) => {
        this.loading = false;
      });
      if (!bool) {
        this.loading = false;
        this.$Message.error("编辑失败，请重新尝试");
      } else {
        this.$emit("finish");
        this.$Message.success("编辑成功！");
        this.cancel();
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.$refs["formInline"].resetFields();
      this.formInline = {
        groupName: "",
        worker: "",
        name: "",
        tel: "",
        email: "",
        showIndex: 0,
      };
      this.$emit("close");
    },
    async handleSuccess(res, file) {
      if (res && res.list.length) {
        // this.uploadList.push({
        //   url: res.list[0],
        //   linkUrl: "",
        //   status: "finished",
        // });
        this.uploadList = this.$refs.upload.fileList;
        console.log(res);
        file.url = res.list[0];
        this.imgurl = res.list[0];

        // let opt = {
        //   Id: this.uploadrow.id,
        //   SetValues: {
        //     GroupName: this.uploadrow.groupName,
        //     Worker: this.uploadrow.worker,
        //     Name: this.uploadrow.name,
        //     Tel: this.uploadrow.tel,
        //     Email: this.uploadrow.email,
        //     ShowIndex: this.uploadrow.showIndex,
        //     QRcode: "",
        //   },
        // };
        // let res1 = await this.editContactUs(opt);
        // if (res1.successed) {
        //   this.init();
        // }
      }
    },
    // 文件格式错误
    handleFormatError(file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg或者png格式的图片`);
    },
    // 文件过大
    handleMaxSize(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于2M的图片`);
    },
    // 上传数量
    handleBeforeUpload() {
      const limitNum = 2;
      const check1 = this.uploadList.length < limitNum;
      if (!check1) {
        this.$Message.warning(`最多上传 ${limitNum} 张图片`);
      }
      return check1;
    },
    // 移除上传图片
    handleRemove(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    getRow() {
      // console.log(row, "row");
      // this.uploadrow = row;
    },
  },
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>
